import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import axios from "axios";
import { toast } from "sonner";
import { API } from "../lib/constants";

export const useWallet = (user) => {
  const qc = useQueryClient();
  const key = ["wallet", user?.user_id || "anon"];

  const q = useQuery({
    queryKey: key,
    queryFn: async () => {
      const { data } = await axios.get(`${API}/wallet`, { withCredentials: true });
      return data;
    },
    enabled: !!user,
    refetchInterval: 60000,
  });

  const claim = useMutation({
    mutationFn: async () => {
      const { data } = await axios.post(`${API}/wallet/claim`, {}, { withCredentials: true });
      return data;
    },
    onSuccess: (data) => {
      qc.setQueryData(key, (old) => ({
        ...(old || {}),
        balance: data.balance,
        can_claim: false,
      }));
      toast.success(`+${data.claimed.toLocaleString("en-US")} $BLUE claimed — big splash!`);
    },
    onError: (e) =>
      toast.error(e.response?.data?.detail || "Claim failed — try again"),
  });

  return { wallet: q.data, claim, claiming: claim.isPending };
};
